import styled from "styled-components";

import { CorporateTicketInfoStyledProps as Props } from "./CorporateTicketInfo.types";

const CorporateTicketInfoStyled = styled.div<Props>`
  padding: 1.6rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;

  .CorporateTicketInfo {
    &__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &__tags {
      display: flex;
      flex-direction: row;
      gap: 0.4rem;
      padding-bottom: 0.8rem;
    }

    &__tag {
      padding: 0.2rem 0.6rem;
      background-color: var(--palette-gray-s0-l30-a40);
      color: var(--palette-white);
      border-radius: 0.6rem;

      &--principal {
        background-color: var(--palette-primary);
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }

    &__svg {
      path {
        fill: var(--palette-white);
      }
    }

    &__title-card {
      color: var(--palette-white);
      font-size: 1.6rem;
      font-weight: 600;
      padding-bottom: 0.6rem;
    }

    &__price {
      font-size: 1.6rem;
      font-weight: 700;
      color: var(--palette-gray-s0-l80);
    }

    &__info {
      color: var(--palette-light-blue-s9-l61);
      font-size: 1rem;
      font-weight: 500;
      padding-top: 0.4rem;
    }

    &__close {
      align-self: self-start;
      padding: 0;
    }
  }
`;

export default CorporateTicketInfoStyled;
